import script from "./HomePagePartnersSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePagePartnersSection.vue?vue&type=script&lang=ts&setup=true"

import "./HomePagePartnersSection.vue?vue&type=style&index=0&id=24257913&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24257913"]])

export default __exports__